import { ERROR_ACTION, WAIT_FOR_ACTION } from "redux-wait-for-action";

export const actionTypes = {
    AUDIT_ASSET_ITEM_CLEAR: "AUDIT_ASSET_ITEM_CLEAR",
    AUDIT_ASSET_ITEM_SET: "AUDIT_ASSET_ITEM_SET",
    AUDIT_ASSET_ITEM_UPDATE: "AUDIT_ASSET_ITEM_UPDATE",
    AUDIT_ASSETS_CLEAR: "AUDIT_ASSETS_CLEAR",

    AUDIT_ASSETS_DATA_UPD: "AUDIT_ASSETS_DATA_UPD",

    AUDIT_ASSETS_SELECT_FAILURE: "AUDIT_ASSETS_SELECT_FAILURE",
    AUDIT_ASSETS_SELECT_REQUEST: "AUDIT_ASSETS_SELECT_REQUEST",
    AUDIT_ASSETS_SELECT_SUCCESS: "AUDIT_ASSETS_SELECT_SUCCESS",

    AUDIT_ASSETS_SELECT_GROUP_FAILURE: "AUDIT_ASSETS_SELECT_GROUP_FAILURE",
    AUDIT_ASSETS_SELECT_GROUP_REQUEST: "AUDIT_ASSETS_SELECT_GROUP_REQUEST",
    AUDIT_ASSETS_SELECT_GROUP_SUCCESS: "AUDIT_ASSETS_SELECT_GROUP_SUCCESS",

    AUDIT_ASSETS_WRITE_FAILURE: "AUDIT_ASSETS_WRITE_FAILURE",
    AUDIT_ASSETS_WRITE_REQUEST: "AUDIT_ASSETS_WRITE_REQUEST",
    AUDIT_ASSETS_WRITE_SUCCESS: "AUDIT_ASSETS_WRITE_SUCCESS",
};

export const actionCreators = {
    clear: () => ({
        type: actionTypes.AUDIT_ASSETS_CLEAR,
    }),

    itemClear: () => ({
        type: actionTypes.AUDIT_ASSET_ITEM_CLEAR,
        saveReduxState: true,
    }),
    itemSet: (auditAsset: any) => ({
        type: actionTypes.AUDIT_ASSET_ITEM_SET,
        payload: { auditAsset },
        saveReduxState: true,
    }),
    itemUpdate: (auditAsset: any) => ({
        type: actionTypes.AUDIT_ASSET_ITEM_UPDATE,
        payload: { auditAsset },
        saveReduxState: true,
    }),

    // TODO: REPLACEMENT PIECE
    setAssetAssigned: (assetIds: any) => ({
        type: actionTypes.AUDIT_ASSETS_DATA_UPD,
        payload: { assetIds },
        saveReduxState: true,
    }),

    selectRequest: (locIds: any, requestType: any, search: any) => ({
        type: actionTypes.AUDIT_ASSETS_SELECT_REQUEST,
        payload: { locIds, requestType, search },
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_ASSETS_SELECT_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_ASSETS_SELECT_FAILURE,
    }),
    selectSuccess: (auditAssets: Array<any>) => ({
        type: actionTypes.AUDIT_ASSETS_SELECT_SUCCESS,
        payload: { auditAssets },
        saveReduxState: true,
    }),
    selectFailure: (error) => ({
        type: actionTypes.AUDIT_ASSETS_SELECT_FAILURE,
        error,
    }),

    selectGroupRequest: (
        auditReference: any,
        requestType: any,
        search: any
    ) => ({
        type: actionTypes.AUDIT_ASSETS_SELECT_GROUP_REQUEST,
        payload: { auditReference, requestType, search },
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_ASSETS_SELECT_GROUP_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_ASSETS_SELECT_GROUP_FAILURE,
    }),
    selectGroupSuccess: (auditAssets: Array<any>) => ({
        type: actionTypes.AUDIT_ASSETS_SELECT_GROUP_SUCCESS,
        payload: { auditAssets },
        saveReduxState: true,
    }),
    selectGroupFailure: (error) => ({
        type: actionTypes.AUDIT_ASSETS_SELECT_GROUP_FAILURE,
        error,
    }),

    writeRequest: (auditAssets: Array<any>) => ({
        type: actionTypes.AUDIT_ASSETS_WRITE_REQUEST,
        payload: { auditAssets },
        [WAIT_FOR_ACTION]: actionTypes.AUDIT_ASSETS_WRITE_SUCCESS,
        [ERROR_ACTION]: actionTypes.AUDIT_ASSETS_WRITE_FAILURE,
    }),
    writeSuccess: (auditAssets: Array<any>) => ({
        type: actionTypes.AUDIT_ASSETS_WRITE_SUCCESS,
        payload: { auditAssets },
        saveReduxState: true,
    }),
    writeFailure: (error) => ({
        type: actionTypes.AUDIT_ASSETS_WRITE_FAILURE,
        error,
    }),
};

export default {
    create: actionCreators,
    type: actionTypes,
};
